import { WebPlugin } from '@capacitor/core';
export class UdpSocketWeb extends WebPlugin {
    async create(options) {
        console.log('create', options);
        throw new Error('Method not implemented.');
    }
    async update(options) {
        console.log('update', options);
        throw new Error('Method not implemented.');
    }
    async setPaused(options) {
        console.log('setPaused', options);
        throw new Error('Method not implemented.');
    }
    async bind(options) {
        console.log('bind', options);
        throw new Error('Method not implemented.');
    }
    async send(options) {
        console.log('send', options);
        throw new Error('Method not implemented.');
    }
    async closeAllSockets() {
        console.log('closeAllSockets');
        throw new Error('Method not implemented.');
    }
    async close(options) {
        console.log('close', options);
        throw new Error('Method not implemented.');
    }
    async getInfo(options) {
        console.log('getInfo', options);
        throw new Error('Method not implemented.');
    }
    async getSockets() {
        console.log('getSockets');
        throw new Error('Method not implemented.');
    }
    async joinGroup(options) {
        console.log('joinGroup', options);
        throw new Error('Method not implemented.');
    }
    async leaveGroup(options) {
        console.log('leaveGroup', options);
        throw new Error('Method not implemented.');
    }
    async setMulticastTimeToLive(options) {
        console.log('setMulticastTimeToLive', options);
        throw new Error('Method not implemented.');
    }
    async setBroadcast(options) {
        console.log('setBroadcast', options);
        throw new Error('Method not implemented.');
    }
    async setMulticastLoopbackMode(options) {
        console.log('setMulticastLoopbackMode', options);
        throw new Error('Method not implemented.');
    }
    async getJoinedGroups() {
        console.log('getJoinedGroups');
        throw new Error('Method not implemented.');
    }
    addListener(eventName, listenerFunc) {
        console.log('addListener', eventName, listenerFunc);
        throw new Error('Method not implemented.');
    }
}
//# sourceMappingURL=web.js.map